module.exports = __webpack_public_path__ + "static/gummy-badge-362e05114d9bed3fd6137db954814711.png";